import React from "react";

function ProductB() {
  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h1>Product B</h1>
      <p style={{ color: "gray" }}>Coming soon.</p>
    </div>
  );
}

export default ProductB;
